import React from 'react';
import classNames from 'classnames';
import ErrorBoundary from '../errors/components/ErrorBoundary';
import ErrorModal from '../errors/components/ErrorModal';
import AccessibilityButtonsWrapper from './AccessibilityButtonsWrapper';
import NavBar from './NavBar';
import OnEsc from './OnEsc';
import PageTitleConfirmation from './PageTitleConfirmation';
import { layoutPadding } from './Layout.constants';
import './Layout.css';

export default function Layout({ children }: React.PropsWithChildren<{}>) {
  return (
    <AccessibilityButtonsWrapper>
      <NavBar />
      <OnEsc />
      <PageTitleConfirmation />
      <ErrorModal />
      <ErrorBoundary>
        {children}
      </ErrorBoundary>
    </AccessibilityButtonsWrapper>
  );
}

export const LayoutBody = ({
  children,
  className,
  style,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    {...props}
    className={classNames('layout-body', className)}
    style={{
      '--layout-padding-desktop': `${layoutPadding.desktop}rem`,
      '--layout-padding-mobile': `${layoutPadding.mobile}rem`,
      ...style,
    } as React.CSSProperties}
  >
    {children}
  </div>
);
